import { render, staticRenderFns } from "./CameraPageShootCheck.vue?vue&type=template&id=67351e7f&scoped=true&"
import script from "./CameraPageShootCheck.vue?vue&type=script&lang=ts&"
export * from "./CameraPageShootCheck.vue?vue&type=script&lang=ts&"
import style0 from "./CameraPageShootCheck.vue?vue&type=style&index=0&id=67351e7f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67351e7f",
  null
  
)

export default component.exports